export default "__VITE_ASSET__0Reg4HDl__"